module.exports = __webpack_public_path__ + "img/bg_01.d8647e1c.png";